import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';

interface ShowAlertParams extends SweetAlertOptions {
    type: SweetAlertIcon;
}

export async function showAlert({
    type,
    title = '',
    text = '',
    toast = true,
    position = 'top-end',
    showConfirmButton = false,
    showCloseButton = true,
    timer = type === 'error' ? 10000 : 3000,
    padding = '2em',
    customClass = 'sweet-alerts',
    icon,
    ...rest
}: ShowAlertParams) {
    if (type === 'success') customClass = 'alert-success';
    if (type === 'error') customClass = 'alert-error';
    if (type === 'info') customClass = 'alert-info';
    if (type === 'warning') customClass = 'alert-warning';

    const alert = Swal.mixin({
        toast,
        position,
        showConfirmButton,
        showCloseButton,
        timer,
        padding,
        customClass,
    });

    const titleHtml = `${title}${text && `<br><small>${text}</small>`}`;

    await alert.fire({
      icon: icon || type,
      title: titleHtml,
      padding,
      customClass,
      ...rest,
    });
}
